import { JSX } from "react";
import { NetworkIntegrityMembership } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface NetworkIntegrityMembershipFilterProps {
  membership: NetworkIntegrityMembership;
  setMembership: (value: NetworkIntegrityMembership) => void;
  primaryMembershipAlias?: string;
  secondaryMembershipAlias?: string;
  disabled?: boolean;
}

const NetworkIntegrityMembershipFilter = (props: NetworkIntegrityMembershipFilterProps): JSX.Element => {
  const { membership, setMembership, primaryMembershipAlias, secondaryMembershipAlias, disabled = false } = props;

  const membershipDisplay: Record<NetworkIntegrityMembership, string> = {
    [NetworkIntegrityMembership.Primary]: primaryMembershipAlias || "Primary Membership",
    [NetworkIntegrityMembership.Secondary]: secondaryMembershipAlias || "Secondary Membership",
  };

  return (
    <QESSelect
      label="View Membership:"
      testId="network-integrity-filters__membership"
      value={membership}
      onChange={(e) => setMembership(e.target.value as NetworkIntegrityMembership)}
      className="network-integrity-filters__membership"
      disabled={disabled}
    >
      {!disabled && Object.values(NetworkIntegrityMembership).map((m) => (
        <option key={`network-integrity-filters__membership-option--${m}`} value={m}>
          {membershipDisplay[m]}
        </option>
      ))}
    </QESSelect>
  );
};

export default NetworkIntegrityMembershipFilter;
